import { render, staticRenderFns } from "./comments-collapsible.vue?vue&type=template&id=2011ba0c"
import script from "./comments-collapsible.ts?vue&type=script&lang=ts&external"
export * from "./comments-collapsible.ts?vue&type=script&lang=ts&external"
import style0 from "./comments-collapsible.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2011ba0c')) {
      api.createRecord('2011ba0c', component.options)
    } else {
      api.reload('2011ba0c', component.options)
    }
    module.hot.accept("./comments-collapsible.vue?vue&type=template&id=2011ba0c", function () {
      api.rerender('2011ba0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/comments-collapsible/comments-collapsible.vue"
export default component.exports